import { Link } from 'react-router-dom';

export default function Footer() {
  const practiceAreas = [
    'Physician & Medical Practices',
    'Specialty Medical Practices',
    'Behavioral & Mental Health',
    'Surgical & Procedure-Based Practices',
    'Vision, Hearing & Specialty Care',
    'Diagnostics & Ancillary Services',
    'Hospitals & Health Systems',
    'Pharmacy & Medication Services',
    'Post-Acute & Long-Term Care',
    'Multi-Location Medical Groups',
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-[#8b0000] text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <a 
              href="https://www.avertnetworkservices.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="inline-block cursor-pointer"
            >
              <img 
                src="https://static.readdy.ai/image/9041450fc173856249e31fa6f138bbf1/f551299d65d78b85b477c46b5802fd7d.png" 
                alt="Healthcare IT Partners" 
                className="h-12 w-auto mb-6"
              />
            </a>
            <p className="text-gray-300 leading-relaxed mb-6 text-sm">
              Your trusted partner for healthcare IT solutions, cybersecurity, and HIPAA compliance. Protecting practices and patients with expert technology services.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-[#e10708] rounded-lg flex items-center justify-center hover:bg-[#c00607] transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-[#e10708] rounded-lg flex items-center justify-center hover:bg-[#c00607] transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-[#e10708] rounded-lg flex items-center justify-center hover:bg-[#c00607] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#e10708] transition-colors flex items-center gap-2 cursor-pointer text-sm">
                  <i className="ri-arrow-right-s-line"></i>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/partners" className="text-gray-300 hover:text-[#e10708] transition-colors flex items-center gap-2 cursor-pointer text-sm">
                  <i className="ri-arrow-right-s-line"></i>
                  Partners
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-gray-300 hover:text-[#e10708] transition-colors flex items-center gap-2 cursor-pointer text-sm">
                  <i className="ri-arrow-right-s-line"></i>
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/cyber-insurance-checklist" className="text-gray-300 hover:text-[#e10708] transition-colors flex items-center gap-2 cursor-pointer text-sm">
                  <i className="ri-arrow-right-s-line"></i>
                  Cyber Insurance
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#e10708] transition-colors flex items-center gap-2 cursor-pointer text-sm">
                  <i className="ri-arrow-right-s-line"></i>
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Practice Areas We Serve */}
          <div>
            <h3 className="text-xl font-bold mb-6">Practice Areas We Serve</h3>
            <ul className="space-y-2 grid grid-cols-2 gap-x-4">
              {practiceAreas.map((area) => (
                <li key={area}>
                  <span className="text-gray-300 text-sm flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-[#e10708] text-xs"></i>
                    {area}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-[#e10708] text-xl flex-shrink-0 mt-1"></i>
                <div>
                  <p className="text-gray-400 text-sm mb-1">Phone</p>
                  <a href="tel:+18552837848" className="text-white hover:text-[#e10708] transition-colors font-medium cursor-pointer">
                    (855) 283-7848
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-[#e10708] text-xl flex-shrink-0 mt-1"></i>
                <div>
                  <p className="text-gray-400 text-sm mb-1">Email</p>
                  <a href="mailto:protectus@healthcareitpartners.com" className="text-white hover:text-[#e10708] transition-colors font-medium cursor-pointer break-all text-sm">
                    protectus@healthcareitpartners.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-[#e10708] text-xl flex-shrink-0 mt-1"></i>
                <div>
                  <p className="text-gray-400 text-sm mb-1">Business Hours</p>
                  <p className="text-white text-sm">Mon - Fri: 8:00 AM - 6:00 PM</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2025 Healthcare IT Partners. All rights reserved. | HIPAA Compliant Services
            </p>
            <div className="flex items-center gap-6 text-sm">
              <a href="#privacy" className="text-gray-400 hover:text-[#e10708] transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#terms" className="text-gray-400 hover:text-[#e10708] transition-colors cursor-pointer">
                Terms of Service
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#e10708] transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
